import { windowWidth } from './utils';

const megamenu = {
  links: document.querySelectorAll(
    '.desc-nav__item',
  ) as NodeListOf<HTMLElement>,

  init() {
    if (windowWidth >= 1649) {
      this.getPosition();
    }
    this.resizePosition();
  },

  getPosition() {
    this.links.forEach((item: HTMLElement) => {
      const megamenu = item.querySelector<HTMLElement>('.desc-nav__sublist');
      if (!megamenu) return;

      const wrapElement =
        document.querySelector<HTMLElement>('.desc-nav__wrap');
      if (!wrapElement) return;

      const bounding = item.getBoundingClientRect();
      const wrapBounding = wrapElement.getBoundingClientRect();
      const megamenuWidth = megamenu.offsetWidth;

      if (
        bounding.left + megamenuWidth / 2 <= wrapBounding.right &&
        bounding.right - megamenuWidth / 2 >= wrapBounding.left
      ) {
        megamenu.style.left = '50%';
        megamenu.style.transform = 'translateX(-50%)';
      } else {
        megamenu.style.left = '0';
        megamenu.style.transform = 'none';

        const megamenuRightEdge = bounding.left + megamenuWidth;
        if (megamenuRightEdge > wrapBounding.right) {
          const overflowAmount = megamenuRightEdge - wrapBounding.right;
          megamenu.style.left = `-${overflowAmount}px`;
        }

        const megamenuLeftEdge = bounding.left;
        if (megamenuLeftEdge < wrapBounding.left) {
          const underflowAmount = wrapBounding.left - megamenuLeftEdge;
          megamenu.style.left = `${underflowAmount}px`;
        }
      }
    });
  },

  resizePosition() {
    window.addEventListener('resize', () => {
      this.getPosition();
    });
  },
};

export default megamenu;
